module.exports = __webpack_public_path__ + "static/media/coming-soon-png-images-5.e3d30c7d.png";